import React from "react";

import {
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  Divider,
} from "@tiny/components";
import { CustomerInfoView } from "@tiny/api";
import TrashFull from "@tiny/icons/generated/TrashFull";
import { useDeleteSubscribersDialog } from "./DeleteSubscribersDialog.hooks";
import DeleteSubscribersRow from "./DeleteSubscribersRow";

export interface DeleteSubscribersDialogProps {
  open: boolean;
  customers: CustomerInfoView[];
  onClose: () => void;
  onSuccess: () => void;
  segmentId?: string;
}

function DeleteSubscribersDialog(props: DeleteSubscribersDialogProps) {
  const { open, onClose } = props;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DeleteSubscribersDialogContent {...props} />
    </Dialog>
  );
}

function DeleteSubscribersDialogContent(props: DeleteSubscribersDialogProps) {
  const { onClose, customers } = props;

  const { deleteCustomers, deleting } = useDeleteSubscribersDialog(props);

  return (
    <>
      <DialogTitle onClose={onClose}>
        Delete subscriber
        {customers.length > 1 ? "s" : ""}?
      </DialogTitle>
      <DialogContent>
        <List>
          <Divider />
          {customers.map((item) => (
            <DeleteSubscribersRow key={item.id} item={item} />
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="outlined"
          color="red"
          onClick={deleteCustomers}
          endIcon={<TrashFull />}
          loading={deleting}
          disabled={deleting}
        >
          Delete
        </Button>
      </DialogActions>
    </>
  );
}

export default DeleteSubscribersDialog;
